module.exports = __webpack_public_path__ + "img/Gefahr_durch_Explosion.a7055433.svg";